import { render, staticRenderFns } from "./ConfigRental.vue?vue&type=template&id=6007c842&"
import script from "./ConfigRental.vue?vue&type=script&lang=js&"
export * from "./ConfigRental.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports